import { render, staticRenderFns } from "./RelatorioDetalhado.vue?vue&type=template&id=e071d67c&scoped=true"
import script from "./RelatorioDetalhado.vue?vue&type=script&lang=js"
export * from "./RelatorioDetalhado.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDetalhado.vue?vue&type=style&index=0&id=e071d67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e071d67c",
  null
  
)

export default component.exports